// useTermsDialogStyles.js
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  outer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    maxWidth: 720,
    margin: '0 auto',
  },
  scrollBox: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    height: 350,
    overflow: 'auto',
    padding: theme.spacing(2),
  },
  controlsRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  controlsRowFooter: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  buttonsRow: {
    display: 'flex',
    gap: theme.spacing(2),
    marginLeft: 'auto'
  },
  footer: {
    marginTop: theme.spacing(2.5),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  paper: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  title: {
    fontWeight: 600,
  },
  content: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  markdownContent: {
    fontFamily: '"Times New Roman", Times, serif',//Preferred, Backup, generic-familys
    fontSize: '11pt',
    lineHeight: 1.6,
    color: theme.palette.text.primary,
    '& h1': {
      fontSize: '11pt',
      fontWeight: 'bold',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    '& h2': {
      fontSize: '11pt',
      fontWeight: 'bold',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    '& h3': {
      fontSize: '11pt',
      fontWeight: 'bold',
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(0.5),
    },
    '& p': {
      marginBottom: theme.spacing(1),
    },
    '& em': {
      fontStyle: 'normal',
      textDecoration: 'underline',
      marginLeft: theme.spacing(1),
    },
    '& strong > em, & em > strong': {
      fontStyle: 'normal',
      textDecoration: 'none',
      fontWeight: 'bold',
      display: 'inline-block',
    },
    '& a': {
      color: theme.palette.type === 'dark' ? '#90caf9' : theme.palette.primary.main,
    },
    '& ul, & ol': {
      paddingLeft: theme.spacing(3),
      marginBottom: theme.spacing(1),
    },
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      marginBottom: theme.spacing(2),
    },
    '& th, & td': {
      border: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(1),
      textAlign: 'left',
    },
    '& th': {
      fontWeight: 'bold',
      backgroundColor: theme.palette.action.hover,
    },
  },
  divider: {
    margin: theme.spacing(4, 0),
    border: 'none',
    borderTop: `2px solid ${theme.palette.divider}`,
  },
  footerDivider: {
    marginTop: theme.spacing(4),
    border: 'none',
    borderTop: `2px solid ${theme.palette.divider}`,
  },
}));